export default __webpack_public_path__ + "images/squigg_red_opt.png";